// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f2a05514","453":"1a724b09","455":"20321e7b","977":"6c839728"}[chunkId] + ".chunk.js";
};